/**
 * Enum representing the different Sentry environments.
 */
var SentryEnv;
(function (SentryEnv) {
    SentryEnv["DEMO"] = "demo";
    SentryEnv["DEV"] = "dev";
    SentryEnv["PREVIEW"] = "preview";
    SentryEnv["PRODUCTION"] = "production";
})(SentryEnv || (SentryEnv = {}));
/**
 * Retrieves the current Sentry "environment" based on the Vite & Vercel environment variables.
 * @returns {SentryEnv} The current Sentry environment.
 */
var getSentryEnv = function () {
    var branch = import.meta.env.VITE_VERCEL_GIT_COMMIT_REF;
    if (import.meta.env.PROD && branch) {
        if (branch.includes(SentryEnv.DEMO)) {
            return SentryEnv.DEMO;
        }
        else if (import.meta.env.VITE_VERCEL_ENV === SentryEnv.PREVIEW) {
            return SentryEnv.PREVIEW;
        }
        return SentryEnv.PRODUCTION;
    }
    return SentryEnv.DEV;
};
export { getSentryEnv, SentryEnv };
